"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var recaptcha_component_1 = require("./recaptcha.component");
var RecaptchaCommonModule = (function () {
    function RecaptchaCommonModule() {
    }
    return RecaptchaCommonModule;
}());
RecaptchaCommonModule = __decorate([
    core_1.NgModule({
        declarations: [recaptcha_component_1.RecaptchaComponent],
        exports: [recaptcha_component_1.RecaptchaComponent],
    })
], RecaptchaCommonModule);
exports.RecaptchaCommonModule = RecaptchaCommonModule;



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/ng2-recaptcha/recaptcha/recaptcha-common.module.js
// module id = ../../../../ng2-recaptcha/recaptcha/recaptcha-common.module.js
// module chunks = 3